import React, { useEffect, useState, useRef } from "react";
import "../styles/news.css";
import NewsDetail from "../components/NewsDetail";

const BUCKET_URL = "https://storage.googleapis.com/ava-architects-news/";

export default function News() {
  const [newsList, setNewsList] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedNews, setSelectedNews] = useState(null);
  const [visibleItems, setVisibleItems] = useState({});
  const cardRefs = useRef({});

  useEffect(() => {
    fetch(`${BUCKET_URL}index.json?v=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => {
        setNewsList(data);
        setFilteredNews(data);
      })
      .catch((err) => console.error("Failed to fetch news:", err));
  }, []);

  useEffect(() => {
    if (selectedNews !== null) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const updated = {};
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const key = entry.target.getAttribute("data-key");
            updated[key] = true;
          }
        });
        setVisibleItems((prev) => ({ ...prev, ...updated }));
      },
      { threshold: 0.2 }
    );

    Object.entries(cardRefs.current).forEach(([key, ref]) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, [filteredNews, selectedNews]);

  const handleBack = () => {
    setSelectedNews(null);
    setVisibleItems({});
  };

  const handleFilter = (category) => {
    setSelectedCategory(category);
    if (category === "All") {
      setFilteredNews(newsList);
    } else {
      setFilteredNews(newsList.filter((item) => item.category === category.toLowerCase()));
    }
    setVisibleItems({});
  };

  if (selectedNews) {
    return <NewsDetail item={selectedNews} onBack={handleBack} bucketUrl={BUCKET_URL} />;
  }

  return (
    <div className="news-container">
      {/* Filter Bar */}
      <div className="news-filter-bar">
        {["All", "Awards", "Events", "Research"].map((cat) => (
          <button
            key={cat}
            className={`filter-btn ${selectedCategory === cat ? "active" : ""}`}
            onClick={() => handleFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* News Cards */}
      {filteredNews.map((item, i) => {
        const imageUrl = `${BUCKET_URL}${encodeURIComponent(item.thumbnail)}`;
        const isEven = i % 2 === 0;
        const key = `news-${i}`;
        const visibleClass = visibleItems[key] ? "visible" : "";

        return (
          <div
            key={key}
            data-key={key}
            className={`news-card ${isEven ? "left-layout" : "right-layout"} ${visibleClass}`}
            onClick={() => setSelectedNews(item)}
            style={{ cursor: "pointer" }}
            ref={(el) => (cardRefs.current[key] = el)}
          >
            <div className="news-image">
              <img src={imageUrl} alt={item.title} />
            </div>
            <div className="news-content">
              <h3>{item.title}</h3>
              <p>{item.brief}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
